export default __webpack_public_path__ + "d367294d4bcfec43c85ef8fdb2931c7d.png";